import {$authApi, $clientApi} from "../http";
import {
    IChangePasswordModel,
    IForgotPasswordStep1Request,
    IForgotPasswordStep2Request, IForgotPasswordStep3Request, IGymTokenResponse,
    ILoginRequest, IModelForUpdateCustomer,
    IRegisterRequest,
    IUserProfile
} from "../models/Auth";
import axios from "axios";

class AuthServiceClass {

    gwtJWT() {
        return localStorage.getItem("refresh_token");
    }

    setTokens(model: { access_token: string, refresh_token: string }) {
        localStorage.setItem("access_token", model.access_token);
        localStorage.setItem("refresh_token", model.refresh_token);
    }

    async login(model: ILoginRequest, endpoint: string) {
        return axios.post<any[]>(`${endpoint}auth/v2/token`, model, {headers: {"Content-Type": "application/json"}});
    }

    async register(model: IRegisterRequest, endpoint: string) {
        return axios.post<null>(`${endpoint}auth/v2/register`, model);
    }

    async createSecondaryAccount(model: {email: string}, endpoint: string) {
        return axios.post<null>(`${endpoint}auth/v2/create-secondary-user`, model);
    }

    async checkEmail(email: string, endpoint: string) {
        return axios.post<[] | {profiles: IUserProfile[], message?: "USER_EXIST_IN_THIS_SYSTEM" | "USER_WAS_DELETED_IN_THIS_SYSTEM"}>(`${endpoint}api/customers/v2-check-exist-customer`, {email});
    }

    checkIsMailValid(email: string) {
        const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        return emailRegex.test(email);
    }

    // async checkEmail(email: string) {
    //     return $clientApi.post<{ existingUser: boolean }>("auth/v2/check-mail", {email: email});
    // }

    logout() {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
    }

    async getProfile() {
        return $clientApi.get<IUserProfile>(`api/user/profile`);
    }

    async forgotPasswordStep1(model: IForgotPasswordStep1Request) {
        return $authApi.post<{ data: null, success: boolean }>("auth/v2/mobile-request-forgot-password", model);
    }

    async forgotPasswordStep2(model: IForgotPasswordStep2Request) {
        return $authApi.post<{ data: { valid: boolean }, success: boolean }>("auth/v2/validate-otp", model);
    }

    async forgotPasswordStep3(model: IForgotPasswordStep3Request) {
        return $authApi.post<{ success: boolean, data: { valid: true } }>("auth/v2/mobile-forgot-password", model);
    }

    async updateProfile(model: IModelForUpdateCustomer) {
        return $clientApi.put<{}>(`api/customers/${model.id}`, model)
    }

    async changePassword(model: IChangePasswordModel) {
        return $authApi.post("api/v2/profile/change-profile-password", model)
    }

    async getGymTokenById(gymId: number) {
        return $clientApi.post<IGymTokenResponse>("auth/v2/authorize-user-by-franchise-token", {gymId});
    }

}

export const AuthService = new AuthServiceClass();